export default "__VITE_ASSET__02fe4968__"